import React, { useState } from 'react';
import { Box } from '@blueprint/ui';

export const NativeCheckbox = ({ label, onChange, checked, id, hasError, ariaDescribedby }) => {
    const [isChecked, setChecked] = useState(false);
    const [cursor, setCursor] = useState('default');
    return (
        <Box display='flex' flexDirection='row'>
            <label>
                <input
                    aria-describedby={ariaDescribedby}
                    className={hasError ? 'hasError' : ''}
                    onMouseEnter={() => {
                        setCursor('pointer');
                    }}
                    onMouseLeave={() => {
                        setCursor('default');
                    }}
                    id={id}
                    aria-checked={isChecked}
                    style={{
                        marginRight: '0.5rem',
                        height: '18px',
                        width: '18px',
                        borderRadius: '0px',
                        borderStyle: 'solid',
                        borderWidth: '0.0625rem',
                        borderColor: '#333333',
                        cusror: 'pointer',
                        backgroundColor: 'white',
                        cursor: cursor,
                    }}
                    type='checkbox'
                    defaultChecked={isChecked}
                    checked={isChecked}
                    onChange={(event) => {
                        setChecked(!isChecked);
                        console.log('Logging checkbox value', event.target.checked);
                        onChange(event);
                    }}
                    onKeyDown={(event) => {
                        if (event.keyCode === 13 || event.keyCode === 32) {
                            console.log('Logging checkbox value', event.target.checked);
                            onChange(event);
                        }
                    }}
                />
                <span style={{ position: 'relative', top: '-0.25em' }}>{label}</span>
            </label>
        </Box>
    );
};

export default NativeCheckbox;
